import React, { useState } from 'react';
import {loginUserId,storeToken} from "../service/UserDetails";
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Checkbox ,notification} from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
//import "./LoginCopy.css";



export default function Login() {
  const [name ,setName] = useState('')
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [token, setToken] = useState(null);
  const [msg, setMessage] = useState("");
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  

  const formItemLayout = {
    labelCol: { xs: { span: 24 }, sm: { span: 30 }, md: { span: 8 }, lg: { span: 8 } },
    wrapperCol: { xs: { span: 35 }, sm: { span: 20 }, md: { span: 50 }, lg: { span: 50 } }
  
  };

  const handleSubmit = async e => {
   // e.preventDefault();
   const user = {username,password}
   
    await loginUserId(user
    ).then((res) => {
        
        if(res.status === 200)
        {
               // setMessage("Please enter correct credentials");
               notification.success({message:"User Successfully Login !"});
               
               const data = res.data
               setToken(data.data.token);
               setRole(data.data.user.role);
               const token1 = 'Bearer ' + data.data.token;
               storeToken(token1)
               localStorage.setItem("loggedIn",true);
               localStorage.setItem("userRole",data.data.user.role)

              // localStorage.setItem("token",data.data.token);
               if(data.data.user.role && data.data.user.role === 'admin'){
                navigate('/admin-all-lead',{state:{user:data.data.user,token: data.data.token}});
               }else if(data.data.user.role && data.data.user.role === 'sales'){
                navigate('/sales-all-leads',{state:{user:data.data.user,token: data.data.token}});
               }else if(data.data.user.role && data.data.user.role === 'survey'){
                navigate('/survey-create-lead',{state:{user:data.data.user,token: data.data.token}});
               }else if(data.data.user.role && data.data.user.role === 'quality'){
                navigate('/quality',{state:{user:data.data.user,token: data.data.token}});
               }
              else{
                //navigate('/quality',{state:{user:data.data.user,token: data.data.token}});
              }
              // navigate('/search-page',{state:{user:data.data.user,token: data.data.token}});
           //    {token && token.data.user.role}
        }
        if (res.status === 401) {
             //   localStorage.setItem("logged_in_status", JSON.stringify(true)); // <-- set localStorage
                 // <-- redirect
                setMessage("Please enter correct credentials");
                notification.warning({message:"Wrong Credentials !"});
                
        }

    })
    .catch(error => {
        console.log({
          error
        })
        notification.error({message:"Authentication failed !"});
        
      })
    
  }
  const onFinish = values => {
    
  };

  return(
    
   // <div className="login-wrapper">
     <div style={{marginTop:'50px'}}>
      <h1 style={{marginRight:'100px'}}>Please Log In</h1>
      <Form
      name="normal_login"
      className="login-form"
      {...formItemLayout}
      initialValues={{
        remember: true,
      }}
      onFinish={handleSubmit}
    >
             {/* <Form.Item
        name="name"
        label="Name"
        rules={[
          {
            required: true,
            message: 'Please input your name!',
          },
        ]}
      >
        <Input onChange={e => setName(e.target.value)}  />
      </Form.Item> */}
      <Form.Item
        name="username"
        rules={[
          {
            required: true,
            message: 'Please input your Username!',
          },
        ]}
      >
        <Input 
        prefix={<UserOutlined className="site-form-item-icon" />} 
        placeholder="Username" 
        type="text"
        style={{marginLeft:'100px',width:'50%'}}
        onChange={e => setUserName(e.target.value)}/>
      </Form.Item>
      <Form.Item
        name="password"
        style={{textAlign:'center'}}
        rules={[
          {
            required: true,
            message: 'Please input your Password!',
          },
        ]}
      >
        <Input
          prefix={<LockOutlined className="site-form-item-icon" />}
          type="password"
          placeholder="Password"
          style={{marginLeft:'100px',width:'50%',textAlign:'center'}}
          onChange={e => setPassword(e.target.value)}
        />
      </Form.Item>
     
      <Form.Item>
        
        <button class="button-demo" role="button" style={{marginLeft:'80px'}}>Log in</button>
      </Form.Item>
      
    </Form></div>
//{/* //      <form class="login">
//   <h2>Welcome, User!</h2>
//   <p>Please log in</p>
//   <input type="text" placeholder="User Name" />
//   <input type="password" placeholder="Password" />
//   <input type="submit" value="Log In" />
//   <div class="links">
//     <a href="#">Forgot password</a>
//     <a href="#">Register</a>
//   </div>
// </form>*/}

//    </div> 
//  <div class="login-container">
//   <div class="login-card">
//    <form class="login-form">
//    <input type="text" placeholder="Username" required></input>
//    <input type="password" placeholder="Password" required></input>
//       <div class="login-buttons">
//         <button type="submit" class="login-button">Login</button>
//       </div>
//    </form>
//   </div>
// </div>
  )
}

//Login.propTypes = {
 // setToken: PropTypes.func.isRequired
//};